module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand12-9ed7c5102558f79cc3bf556bd44c5d35.jpg";